import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-promo-sticky',
  templateUrl: './promo-sticky.component.html',
  styleUrls: ['./promo-sticky.component.scss'],
  animations: [
    trigger('stickyAnim', [
      transition(':enter', [
        style({
          transform: 'translate3d(0,-150%,0)',
          opacity: 0
        }),
        animate(
          '.25s ease-in',
          style({
            transform: 'translate3d(0,0,0)',
            opacity: 1
          })
        )
      ]),
      transition(':leave', [
        style({
          transform: 'translate3d(0,0,0)',
          opacity: 1
        }),
        animate(
          '.25s ease-out',
          style({
            transform: 'translate3d(0,-150%,0)',
            opacity: 0
          })
        )
      ])
    ])
  ]
})
export class PromoStickyComponent implements OnInit {
  public isSticky = true;
  public lottoId: number;
  public subs: Subscription;
  constructor(protected lotto: LottosService) {}

  ngOnInit(): void {
    this.getLottoId();
  }

  getLottoId(): void {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.lottoId = lottoObj['id'];
    });
  }

  get setBgColor() {
    return `bg-product-${this.lottoId}`;
  }

  closeSticky(): void {
    this.isSticky = !this.isSticky;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
